import { Drawer, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { EInvoicingDisableModal } from '@features/eInvoicing/elements/EInvoicingDisableModal'
import { useEInvoicingSetup } from '@features/eInvoicing/hooks/useEInvoicingSetup'

import { EInvoicingSection } from './elements/EInvoicingSection'
import { ScoutConnections } from './elements/ScoutConnections'

export const ReceiptsSidePanel = (): ReactElement => {
  const { t } = useTranslation()

  const { isEInvoicingEnabled, isUserAuthorizedForKYC } = useEInvoicingSetup()

  const displayEInvoicesSection = isEInvoicingEnabled && isUserAuthorizedForKYC

  return (
    <>
      <Drawer>
        <Drawer.Header icon="zap" title={t('receipts.side_panel.title')} />
        <Drawer.Body>
          <Flex flexDirection="column" gap={Spacing.S8} justifyContent="center">
            <Text variant="h4" weight="bold">
              {t('receipts.side_panel.receipt_finder.title')}
            </Text>
            <Text>{t('receipts.side_panel.receipt_finder.description')}</Text>
          </Flex>
          <ScoutConnections />

          {displayEInvoicesSection ? <EInvoicingSection /> : null}
        </Drawer.Body>
      </Drawer>

      <EInvoicingDisableModal />
    </>
  )
}
